import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel } from './SectionLabel';
import { galleryItems } from '../data/gallery';
const spanClasses: Record<string, string> = {
  tall: 'sm:row-span-2 sm:col-span-1',
  square: 'sm:col-span-1',
  wide: 'sm:col-span-1 lg:col-span-1'
};
export function Gallery() {
  return <section className="w-full border-y border-ink/10 bg-oat/40" data-id="element-35" data-mp="3deg0oao4nwpt">
      <div className="mx-auto w-full max-w-6xl px-5 py-12 sm:px-6 sm:py-16 lg:py-24" data-id="element-36" data-mp="2pn0weccsj5bx">
        <div className="max-w-2xl" data-id="element-37" data-mp="2koqy3svrrom3">
          <SectionLabel data-id="element-38" data-mp="2kpsaq1sfoj5x">Galería</SectionLabel>
          <h2 className="font-display text-[1.6rem] leading-tight text-ink sm:text-4xl lg:text-[2.75rem]" data-id="element-39" data-mp="2kmml8lfw7f9o">
            Mirá todo lo que podés crear
          </h2>
          <p className="mt-4 font-sans text-[15px] leading-relaxed text-ink/65 sm:mt-5 sm:text-base" data-id="element-40" data-mp="2ul2dirqnoukr">
            Desde barras grandes de boutique hasta jaboncillos para souvenirs:
            una misma técnica, infinitas piezas para vender.
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:mt-12 sm:grid-cols-2 sm:gap-5 lg:grid-cols-3" data-id="element-41" data-mp="rdcnqrl8i659">
          {galleryItems.map((item, index) => <motion.figure key={item.title} initial={{
          opacity: 0,
          y: 22
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.55,
          delay: index % 3 * 0.08,
          ease: [0.22, 1, 0.36, 1]
        }} className={`group relative overflow-hidden rounded-[1.75rem] border border-ink/10 bg-cream shadow-soft ${spanClasses[item.span]}`} data-id="element-42" data-mp="w9jgtjsj7n5s" data-mpi={index}>
              <div className={`overflow-hidden ${item.span === 'tall' ? 'aspect-[4/3] sm:aspect-[3/5]' : item.span === 'wide' ? 'aspect-[4/3]' : 'aspect-[4/3] sm:aspect-square'}`} data-id="element-43" data-mp="me9gd0hs7nu4">
                <img src={item.image} alt={item.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]" data-id="element-44" data-mp="3txup6f00autn" />
              </div>
              <figcaption className="border-t border-ink/10 bg-cream px-4 py-3.5 sm:px-5 sm:py-4" data-id="element-45" data-mp="2q06antozayf">
                <h3 className="font-display text-base leading-snug text-ink sm:text-lg" data-id="element-46" data-mp="3b5js51s19r3g">
                  {item.title}
                </h3>
                <p className="mt-1 font-sans text-[13px] leading-relaxed text-ink/60 sm:text-sm" data-id="element-47" data-mp="3kutl0jupbdsm">
                  {item.description}
                </p>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}